import * as t from "io-ts";
import { Branding } from "./Branding";
import { ContactInfo } from "./ContactInfo";
import { EnterpriseUserType } from "./EnterpriseUserType";
import { LenderConfig } from "./LenderConfig";
import { Metadata } from "./Metadata";

export const Enterprise = t.intersection([
  t.type({
    enterprise_type: t.union([
      t.literal("main_office"),
      t.literal("area_office"),
      t.literal("region_office"),
      t.literal("branch_office"),
    ]),
    contact_info: ContactInfo,
  }),
  t.partial({
    id: t.string,
    cid: t.string,
    aid: t.string,
    oid: t.string,
    eid: t.string,
    bid: t.string,
    subdomain: t.string,
    branch_code: t.string,
    emails: t.array(t.string),
    users: t.array(EnterpriseUserType),
    branding: Branding,
    lender_configs: t.array(LenderConfig),
    metadata: Metadata,
  }),
]);

export interface Enterprise {
  id?: string;
  cid?: string;
  aid?: string;
  oid?: string;
  eid?: string;
  bid?: string;
  enterprise_type:
    | "main_office"
    | "area_office"
    | "region_office"
    | "branch_office";
  subdomain?: string;
  branch_code?: string;
  emails?: Array<string>;
  users?: Array<EnterpriseUserType>;
  contact_info: ContactInfo;
  branding?: Branding;
  lender_configs?: Array<LenderConfig>;
  metadata?: Metadata;
}
